import ChatRoomcreateForm from "@/components/chat/ChatRoomCreateForm.vue";
import io from "socket.io-client";
export  const chatroomcreate = {
  data() {
    return {
      title: "",
      subtitle: "",
      max: "",
      limitation: "",
      category:"",
      icon: "",
      url:null,
      imageUrl:"",
      formIsValid: true,
      socket: io(this.$store.state.serverDomain + ":3000"),
    };
  },
  components:{
    ChatRoomcreateForm
  },
  // created(){
  //   this.$store.dispatch('tryLogin');
  // },
  computed: {
    submitButtonCaption() {
      return "생성하기";
    },
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.icon =file;
      let reader = new FileReader();
      reader.readAsDataURL( file );

      reader.onload = () => {
            this.imageUrl = reader.result;
      };
      this.url = URL.createObjectURL(file);
    },
   async saveData(data) {
      console.log(data);

      try {
        //const response = await auth.login(actionPayload);
        const response = await this.$store.dispatch("chat/createRoom", data);
        console.log("응답"+response);
        this.socket.emit("MakeRoom",{room_id:'room_'+response.room_id});
        if(this.isMobile)
        {
          this.$emit("createroom",response.room_id);          
        }else{
          this.$router.replace("/chat/room/"+ response.room_id); 
        }       
        
        

        this.$flashMessage.show({
          type: "info",
          title: response.message,
          message: response.message,
        });
      } catch (error) {
        console.log("에러"+ JSON.stringify(error.response.data));
        switch (error.response.status) {
          case 422:
            this.$flashMessage.show({
              type: "error",
              title: "유효하지 않은 데이터 입력입니다.",
              message: "유효하지 않은 데이터 입력입니다.",
            });
            break;
          case 401:
            setTimeout(() => (this.$router.push('/auth/login')), 1000)
            this.$flashMessage.show({
              type: "error",
              title:  "로그인이 필요합니다.",
              //message: "로그인이 필요합니다.",
            });
            break;
          case 500:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });

            if(this.isMobile)
            {
              this.tryClose();
            }else{
              this.$router.replace("/chat/lobby");  
            }

            break;
          default:
            this.$flashMessage.show({
              type: "error",
              title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
              message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
            });
            break;
        }
      }
    },
    chatLobby(){
        this.$router.replace("/chat/lobby");
    }
  },
};